import { useAppSelector } from 'app/hooks';
import axios from 'axios';
import AlertBox from 'blocks/AlertBox';
import Button from 'blocks/Button';
import BaseModal from 'components/modals/BaseModal';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { UserTierState, setUserTiers } from 'store/tiers/tiersSlice';
import urls from 'utils/urls';
import { ContentProps, ModalTypes } from './convertMilesModal.interface';
import * as S from './convertMilesModal.styles';

const Content = ({ open, closeModal, miles, tierMilage }: ContentProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userTiers = useAppSelector(UserTierState);
  const [rewardMilage, seRewardMilage] = useState<any>(userTiers?.rewardMilage);
  const [step, setStep] = useState<ModalTypes>(ModalTypes.confirmation);
  const [recieptInfo, setRecieptInfo] = useState({
    converteMile: '',
  });

  const convert = async () => {
    let data = {};
    data = {
      mile: miles,
    };

    const res = await axios.post(urls.convertMile, data);
    setStep(ModalTypes.success);
    setRecieptInfo({
      converteMile: res.data.convertMile,
    });
    if (!res) return;

    if (userTiers !== null) {
      dispatch(
        setUserTiers({
          ...userTiers,
          tierMilage: res.data.user.tierMilage,
          rewardMilage: res.data.user.rewardMilage,
        })
      );
    }
  };

  return (
    <S.ConvertMilageModal>
      {step === ModalTypes.confirmation && (
        <>
          <S.ModalType1>{t('pages.services.convertMilage.sections.modals.confirmation.title')}</S.ModalType1>

          <S.ModalType2>
            {t('pages.services.convertMilage.sections.modals.confirmation.subtitle', { miles })}
          </S.ModalType2>

          <S.GrayCard>
            <S.RowList $remain={false}>
              <S.RowListGrayText>
                {t('pages.services.convertMilage.sections.modals.confirmation.keyValues.currentMiles')}
              </S.RowListGrayText>
              <S.RowListGrayText>{userTiers?.rewardMilage}</S.RowListGrayText>
            </S.RowList>
            <S.RowList $remain={false}>
              <S.RowListErrorText>
                {t('pages.services.convertMilage.sections.modals.confirmation.keyValues.miles')}
              </S.RowListErrorText>
              <S.RowListErrorText>{miles}</S.RowListErrorText>
            </S.RowList>
            <S.RowList $remain={true}>
              <S.RowListGrayText>
                {t('pages.services.convertMilage.sections.modals.confirmation.keyValues.remainingMiles')}
              </S.RowListGrayText>
              <S.RowListGrayText>{(userTiers?.rewardMilage || 0) - Number(miles)}</S.RowListGrayText>
            </S.RowList>
          </S.GrayCard>

          <S.GrayCard>
            <S.RowList $remain={false}>
              <S.RowListGrayText>
                {t('pages.services.convertMilage.sections.modals.confirmation.keyValues2.currentMiles')}
              </S.RowListGrayText>
              <S.RowListGrayText>{userTiers?.tierMilage}</S.RowListGrayText>
            </S.RowList>
            <S.RowList $remain={false}>
              <S.RowListSuccessText>
                {t('pages.services.convertMilage.sections.modals.confirmation.keyValues2.miles')}
              </S.RowListSuccessText>
              <S.RowListSuccessText>{tierMilage}</S.RowListSuccessText>
            </S.RowList>
            <S.RowList $remain={true}>
              <S.RowListGrayText>
                {t('pages.services.convertMilage.sections.modals.confirmation.keyValues2.remainingMiles')}
              </S.RowListGrayText>
              <S.RowListGrayText>{(userTiers?.tierMilage || 0) + Number(tierMilage)}</S.RowListGrayText>
            </S.RowList>
          </S.GrayCard>

          <S.BtnContainer>
            <S.BtnActiveText as={Button} styleType="text-button" onClick={closeModal}>
              {t('pages.services.convertMilage.sections.modals.confirmation.cancelCTA')}
            </S.BtnActiveText>
            <S.BtnActiveDefult as={Button} styleType="default" onClick={convert}>
              {t('pages.services.convertMilage.sections.modals.confirmation.submitCTA')}
            </S.BtnActiveDefult>
          </S.BtnContainer>
        </>
      )}

      {step === ModalTypes.success && (
        <S.ConvertMilesReceipt>
          <AlertBox type="success" text={t('pages.services.convertMilage.sections.modals.success.title')} />

          <S.Divider></S.Divider>

          <S.BtnContainer>
            <S.BtnActiveDefult as={Button} styleType="default" onClick={closeModal}>
              {t('pages.services.convertMilage.sections.modals.success.closeCTA')}
            </S.BtnActiveDefult>
          </S.BtnContainer>
        </S.ConvertMilesReceipt>
      )}
    </S.ConvertMilageModal>
  );
};

interface State {
  open: boolean;
}

interface Props {
  ref: any;
  miles: string;
  tierMilage: string;
}

class ConvertMilageModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  openModal = (): void => this.setState({ open: true });

  closeModal = (): void => this.setState({ open: false });

  render() {
    return (
      <BaseModal open={this.state.open} closeModal={this.closeModal}>
        <Content {...this.props} open={this.state.open} closeModal={this.closeModal} />
      </BaseModal>
    );
  }
}

export default ConvertMilageModal;
